<template>
    <c-nav-item>
        <slot/>
    </c-nav-item>
</template>
<script setup>
import {CNavItem} from "@coreui/vue/dist/esm/components/nav/index.js";
</script>
